export default "__VITE_ASSET__tVs7jC2I__"